var map = {
	"./person-qrcode.jpg": 27298,
	"./元习.jpg": 86079,
	"./元习小程序.jpg": 79918,
	"./双创思维.jpg": 78890,
	"./舟知.jpg": 41266,
	"./超级教案.jpg": 68117
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16313;